import Container from "components/atoms/layout/Container/Container";
import LeadScoringModule from "components/modules/scoring";
import { FC } from "react";

export const ScoringFilter: FC = () => {
  return (
    <Container className="p-10  overflow-y-auto max-h-[80vh]">
      <LeadScoringModule />
    </Container>
  );
};
